import styled from "styled-components";

const Step = ({ primary, children }) => {
  return (
    <StyledText>
      <h3 className="primary-text">{primary}/</h3>
      <p className="secondary-text">{children}</p>
    </StyledText>
  );
};

const StyledText = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 370px;
  width: 100%;
  white-space: pre-wrap;
  .primary-text {
    display: flex;
    align-items: center;
    font-size: 5.625rem;
    font-weight: 700;
    color: rgba(0, 0, 255, 1);
    margin: 0;
  }
  .secondary-text {
    font-size: 20px;
    line-height: 23px;
    width: 100%;
  }

  @media (max-width: 445px) {
    font-size: 18px;
  }
`;

export default Step;
